import React from "react";
import { components, GroupBase, InputProps } from "react-select";

const { Input } = components;

export function CustomInput<
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>
>(props: InputProps<Option, IsMulti, Group>) {
  const { testIdKey } = props.selectProps ?? {};

  return <Input {...props} data-testid={`${testIdKey}_field_input`} />;
}
